import React from 'react';
import { mustShowLegalLinks } from 'utilities/logicByCountry';
import { LEGAL_POINTS } from '../constants';
import { LegalListItem } from '../LegalListItem/LegalListItem';

export const getLegalItems = productsInfo =>
    Array.from({ length: LEGAL_POINTS }, (_, i) => i + 1)
        .filter(mustShowLegalLinks)
        .map(index => <LegalListItem key={index} index={index} productsInfo={productsInfo} />);
